<template>
  <div class="game maze">
    <p>{{ $t('Please complete this maze.') }}</p>

    <WilsonMaze
      :width="settings.width"
      :height="settings.height"
      :cell-size="settings.cellSize"
      @game-completed="handleGameCompleted"
    />

    <div class="actions" :class="{ enabled: showReadyButton }">
      <button type="button" @click.prevent="emitReady">
        {{ $t('done') }}
      </button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, onMounted, ref } from 'vue'

import WilsonMaze from './WilsonMaze.vue'

const props = defineProps<{
  level: number
}>()

const emit = defineEmits<{
  ready: []
}>()

const settings = computed(() => {
  if (props.level === 0) {
    return {
      width: 10,
      height: 10,
      cellSize: 20,
    }
  }

  if (props.level === 1) {
    return {
      width: 12,
      height: 12,
      cellSize: 20,
    }
  }

  return {
    width: 18,
    height: 18,
    cellSize: 32,
  }
})

const showReadyButton = ref(false)

const handleGameCompleted = () => {
  showReadyButton.value = true
}

const emitReady = () => {
  if (!showReadyButton.value) {
    return
  }

  emit('ready')
}

onMounted(() => {
  if (props.level === 0) {
    showReadyButton.value = true
    emitReady()
    return
  }
})
</script>

<style scoped>
.game.maze {
  text-align: center;
}

.actions {
  pointer-events: none;

  & button {
    opacity: 0;
    transition: opacity 0.2s ease;
  }

  &.enabled {
    pointer-events: auto;

    & button {
      opacity: 1;
    }
  }
}
</style>
